





















import { Component, Prop, Vue } from "vue-property-decorator";
import { eventService } from "../services/EventService";

@Component({
  components: {}
})
export default class DialogFullScreen extends Vue {
  @Prop({ type: String, default: "DialogFullScreen-Close" })
  closeEvent: any | string;

  @Prop({ type: String, default: "DialogFullScreen-Save" })
  saveEvent: any | string;

  @Prop({ type: Boolean, default: false })
  visible: boolean = false;

  @Prop({ type: String, default: "" })
  nameComponent: any | string;

  @Prop()
  propsComponent: any;

  @Prop({ type: String, default: "persistent" })
  type: any | string;

  fullscreen: boolean = false;
  persistent: boolean = false;

  @Prop({ type: String, default: "" })
  title: any | string;

  @Prop({ type: String, default: "Guardar" })
  saveText: any | string;

  created() {

    switch (this.type) {
      case "fullscreen":
        this.fullscreen = true;
        break;
      case "persistent":
        this.persistent = true;
        break;

      default:
        this.fullscreen = true;
        break;
    }
  }

  destroyed(){
    eventService.off(this.closeEvent);
    eventService.off(this.saveEvent);
  }

  close() {
    eventService.emit(this.closeEvent, null);
  }

  save() {
    eventService.emit(this.saveEvent, null);
  }
}
